//import * as firebase from 'firebase';
//import 'firebase/auth';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/database';
import 'firebase/storage';
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
// Your web app's Firebase configuration

var firebaseConfig = {
  apiKey: "AIzaSyDL9UZbEADiaCQd0dXcit8jPDQAJu0pOe4",
  authDomain: "casaduana-ef880.firebaseapp.com",
  databaseURL: "https://casaduana-ef880-default-rtdb.firebaseio.com",
  projectId: "casaduana-ef880",
  storageBucket: "casaduana-ef880.firebasestorage.app",
  messagingSenderId: "841053718418",
  appId: "1:841053718418:web:d07e58d76967059d6a234b",
  measurementId: "G-XEKWCJ9E4H"
};
  // Initialize Firebase
  //firebase.initializeApp(firebaseConfig);
  //firebase.analytics();
// Initialize Firebase

const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

  class Firebase {

    app;

    constructor(){
            
        this.app = firebase;
        this.conexion = firebase.database();
        
    }


    obtener_webinars_usuario = (url, campo, valor, funct) => {

        this.conexion.ref(url).once('value', (objetos) => {

            if (this.collectionToArr(objetos).length > 0) {

                let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {

                    if (objeto[campo] === valor) {
                        return true;
                    } else {
                        return false;
                    }
                });

                if(objeto_buscado.length > 0){
                    return funct(objeto_buscado[0]);
                }else{
                    return funct(null);
                }
            }
            return funct(null);
        })
    }
    
    obtener_objeto = (url, campo, valor, funct) => {
        
        this.conexion.ref(url).once('value', (objetos) => {

            if (this.collectionToArr(objetos).length > 0) {

                let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {
                    if (objeto[campo] === valor) {
                        return true;
                    } else {
                        return false;
                    }
                });
                if(objeto_buscado.length === 1){
                    return funct(objeto_buscado[0]);
                }else{
                    const datos_objeto = {};
                    datos_objeto[campo] = valor;
                    this.escribir(url, undefined, datos_objeto, funct);
                }
            } else {
                const datos_objeto = {};
                datos_objeto[campo] = valor;
                this.escribir(url, undefined, datos_objeto, funct);
            }
        });
    }

    verificar_objeto = (url, campo, valor, funct) => {
        
        this.conexion.ref(url).once('value', (objetos) => {

            if (this.collectionToArr(objetos).length > 0) {

                let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {
                    if (objeto[campo] === valor) {
                        return true;
                    } else {
                        return false;
                    }
                });


                if(objeto_buscado.length > 0){
                    funct(true);
                }else{
                    funct(false);
                }
            } else {
                funct(false);
            }
        });
    }

    escribir = (url, id, objeto, funct) => { //sendquestion || updateQuestion
        let key = '';
        if (id === undefined) {
            key = this.conexion.ref(url).push().key;
        } else {
            key = id;
        }

        this.conexion.ref(url).child(key).set(objeto, () => {
            objeto['key'] = key;
            return funct(objeto);
        });
    }

    obtener_objetos = (url, escuchar ,funct) => { //questions

        if(escuchar){
            this.conexion.ref(url).orderByChild("num_pregunta").on('value', (objetos) => {
                return funct(this.collectionToArr(objetos));
            })
        }else{
            this.conexion.ref(url).orderByChild("num_pregunta").once('value', (objetos) => {
                return funct(this.collectionToArr(objetos));
            })
        }
    }

    obtener_parametro = (url, escuchar ,funct) => {

        if(escuchar){
            this.conexion.ref(url).on('value', (parametro) => {
                return funct(parametro);
            })
        }else{
            this.conexion.ref(url).once('value', (parametro) => {
                return funct(parametro);
            })
        }
    }

    collectionToArr = (collection) => {
        var rows = [];
        if (collection && collection.val()) {

            collection.forEach((obj) => {
                let item = obj.val();
                item.key = obj.key;
                rows.push(item);
            });
        }
        return rows;
    }


}

export default Firebase;